export const IMPERSONATION_COOKIE =
  process.env.NEXT_PUBLIC_ENVIRONMENT === "production"
    ? "_stadium.impersonate_as"
    : "_stadium_non_prod.impersonate_as";

export const STADIUM_IMPERSONATION_COOKIE_DOMAIN = (() => {
  const hostname = globalThis.location?.hostname;
  if (hostname) {
    // use only the tld and the domain name
    return `.${hostname.split(".").slice(-2).join(".")}`;
  }
  return ".bystadium.com"; // fallback to the default domain (server side compilation)
})();
